import EduContentRoomModel from '../Apis/EduContentRoom'
import Controller from './Controller'

export default class EduContentRoomController extends Controller {
  constructor() {
    super(new EduContentRoomModel())
  }

  
}
